import { render, staticRenderFns } from "./IceHockeyArena.vue?vue&type=template&id=4eba1316&scoped=true"
import script from "./IceHockeyArena.vue?vue&type=script&lang=js"
export * from "./IceHockeyArena.vue?vue&type=script&lang=js"
import style0 from "./IceHockeyArena.vue?vue&type=style&index=0&id=4eba1316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eba1316",
  null
  
)

export default component.exports